import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { eventsAPI } from "../../services/api";
import Modal from "../../components/common/Modal";

const initialForm = {
  id: null,
  type: "",
  date: "",
  start_time: "",
  end_time: "",
  title: "",
  roleType: "",
  description: "",
};

const EventsHolidays = () => {
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState(initialForm);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchEvents = async () => {
    try {
      setLoading(true);
      const res = await eventsAPI.getAll();
      setData(res.data.results || res.data);
    } catch (error) {
      toast.error("Failed to load events");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);
  const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
    ...(name === "type" && value === "Holiday"
      ? {
          start_time: null,
          end_time: null,
        }
      : {}),
  }));
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (formData.id) {
        await eventsAPI.update(formData.id, formData);
        toast.success("Event updated successfully");
      } else {
        await eventsAPI.create(formData);
        toast.success("Event added successfully");
      }

      fetchEvents();
      setFormData(initialForm);
      setShowModal(false);
    } catch (error) {
      toast.error("Failed to save event");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) {
      return;
    }

    try {
      await eventsAPI.delete(id);
      toast.success("Deleted successfully");
      fetchEvents();
    } catch (error) {
      toast.error("Delete failed");
    }
  };

  const filteredData = data.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <>
      <div className="card shadow-sm">
        {/* Header */}
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="mb-0 text-uppercase">
            List Of Holidays & Events
          </h4>
          <button className="btn-add" onClick={() => {
            setFormData(initialForm);
            setShowModal(true);
          }}>➕ Add New</button>
          {/* <button
            className="btn btn-primary"
            onClick={() => {
              setFormData(initialForm);
              setShowModal(true);
            }}
          >
            <i className="bi bi-plus-lg me-1"></i>
            Add New
          </button> */}
        </div>

        {/* Year Filter */}
        <div className="row my-4">
          <div className="col-md-3 mx-auto">
            <select className="form-select">
              <option>2026</option>
              <option>2027</option>
              <option>2028</option>
            </select>
          </div>
        </div>

        {/* Top Controls */}
        <div className="card-body">
          <div className="d-flex justify-content-between mb-3">
            <div className="d-flex gap-2">
              <select
                className="form-select"
                style={{ width: "80px" }}
              >
                <option>10</option>
                <option>25</option>
                <option>50</option>
              </select>

              <button className="btn btn-secondary">
                <i className="bi bi-cloud-download-fill"></i>
              </button>
            </div>

            <div className="d-flex align-items-center gap-2">
              <label>Search:</label>

              <input
                type="text"
                className="form-control"
                style={{ width: "220px" }}
                value={search}
                onChange={(e) =>
                  setSearch(e.target.value)
                }
              />
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>S.No</th>
                  <th>Type</th>
                  <th>Date</th>
                  <th>Title</th>
                  <th>Role Type</th>
                  <th>Description</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th width="120">Actions</th>
                </tr>
              </thead>

              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>

                      <td>
                        {item.type === "Holiday" ? (
                          <span className="badge bg-danger">
                            Holiday
                          </span>
                        ) : (
                          <span className="badge bg-primary">
                            Event
                          </span>
                        )}
                      </td>

                      <td>{item.date}</td>
                      <td>{item.title}</td>
                      <td>{item.roleType}</td>
                      <td>{item.description}</td>
                      <td>{item.start_time}</td>
                      <td>{item.end_time}</td>
                      <td>
                        <button
                          className="btn btn-success btn-sm me-2"
                          onClick={() => {
                            setFormData(item);
                            setShowModal(true);
                          }}
                        >
                          <i className="bi bi-pencil"></i>
                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() =>
                            handleDelete(item.id)
                          }
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center py-4"
                    >
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <button className="btn btn-info text-white mt-3">
            Export to Excel
          </button>
        </div>
      </div>

      {/* Add/Edit Modal */}
      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        title={
          formData.id
            ? "Edit Holiday / Event"
            : "Add Holiday / Event"
        }
        size="md"
      >
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Type
              </label>

              <select
                className="form-select"
                name="type"
                value={formData.type}
                onChange={handleChange}
                required
              >
                <option value="">
                  Select
                </option>

                <option value="Holiday">
                  Holiday
                </option>

                <option value="Event">
                  Event
                </option>
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">
                Date
              </label>

              <input
                type="date"
                className="form-control"
                name="date"
                value={formData.date}
                onChange={handleChange}
                
              />
            </div>

            {
              formData.type === "Event" && (
                <>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Start Time
                    </label>

                    <input
                      type="time"
                      className="form-control"
                      name="start_time"
                      value={formData.start_time}
                      onChange={handleChange}
                      
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      End Time
                    </label>

                    <input
                      type="time"
                      className="form-control"
                      name="end_time"
                      value={formData.end_time}
                      onChange={handleChange}
                      
                    />
                  </div>
                </>
              )
            }


            <div className="col-md-12 mb-3">
              <label className="form-label">
                {formData.type === "Holiday"
                  ? "Holiday Name"
                  : "Event Name"}
              </label>

              <input
                type="text"
                className="form-control"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-12 mb-3">
              <label className="form-label">
                Role Type
              </label>

              <select
                className="form-select"
                name="roleType"
                value={formData.roleType}
                onChange={handleChange}
              >
                <option value="">
                  --- Select ---
                </option>

                <option value="All">
                  All
                </option>

                <option value="Student">
                  Student
                </option>

                <option value="Teacher">
                  Teacher
                </option>

                <option value="Staff">
                  Staff
                </option>
              </select>
            </div>

            <div className="col-md-12 mb-4">
              <label className="form-label">
                Description
              </label>

              <textarea
                rows="4"
                className="form-control"
                name="description"
                value={formData.description}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-12">
              <button
                type="submit"
                className="btn btn-info text-white me-2"
              >
                {formData.id
                  ? "Update"
                  : "Submit"}
              </button>

              <button
                type="button"
                className="btn btn-light border"
                onClick={() =>
                  setShowModal(false)
                }
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default EventsHolidays;